// A line is the GRANTED (free) gift only when it actually costs nothing —
// `final_price === 0`. The `_freegift` line property is deliberately NOT
// consulted: the property survives in the cart while the gift is retained
// after the qualifying threshold drops, so a property check would keep
// showing "FREE GIFT" on a line the buyer is now being charged for.
// A discount allocation is not enough either — an ordinary promo on a paid
// line carries one.
//
// A buyer's OWN full-price purchase of the gift variant, and a retained gift
// that has reverted to full price, both render as ordinary lines: they keep
// their price, their stepper and their remove button.
export function isGrantedGift(item) {
    return item.final_price === 0;
}
// Gift lines render above paid lines, matching the reference implementation,
// which achieved it with two separate render passes. Returns a new array;
// Array.prototype.sort is in-place and the caller's array is React state.
export function sortGiftsFirst(items) {
    return [...items].sort((a, b) => Number(isGrantedGift(b)) - Number(isGrantedGift(a)));
}
